export default __webpack_public_path__ + "static/media/bbb8cedebf80eb6dac7c334c8b364522.gif";